import variables from '../sass/_variables.scss';
import _ from 'lodash';

const stickyHeader = () => function(){
    var topbar = $("#topbar_content_id");
    var topbar_placeholder = $("#topbar_content_placeholder_id");
    if (topbar.text().trim() != "" && window.pageYOffset > parseInt(variables.header_height) + 50) {
        topbar_placeholder.show();
        topbar.addClass("sticky");
        if ($(".nav-container").length == 0){
            topbar.css('top', 0);
        }
    } else {
        topbar.removeClass("sticky");
        topbar_placeholder.hide();
    }
};

window.addEventListener("scroll", _.debounce(stickyHeader(), 15));